import MainShapeType from './contraCP/types/mainShapeType';
import FontLoaderFonts from './contraCP/types/fontLoaderFonts';
import Validator from './configurator/validator';

const mainShapeParams = new Map();

mainShapeParams.set(MainShapeType.Rect, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700]
    ]),
    validator: Validator.factory(MainShapeType.Rect),
    validators: [
        model => model.w < 50 ? {propName: 'w', propValue: 50, message: ['configurator.errors.minimumWidth', {min: 50}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumHeight', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.RoundedRect, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700],
        ['r', 100]
    ]),
    validator: new Validator.factory(MainShapeType.RoundedRect),
    validators: [
        model => model.w < 50 ? {propName: 'w', propValue: 50, message: ['configurator.errors.minimumWidth', {min: 50}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumHeight', {min: 50}]} : false,
        model => {
            const maxRadius = Math.floor(Math.min(model.h / 2, model.w / 2));
            return (model.r > maxRadius) ? {
                propName: 'r',
                propValue: maxRadius,
                message: ['configurator.errors.maximumRadius', {max: maxRadius}]
            } : false
        }
    ]
});

mainShapeParams.set(MainShapeType.Rhombus, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700]
    ]),
    validator: Validator.factory(MainShapeType.Rhombus),
    validators: [
        model => model.w < 50 ? {propName: 'w', propValue: 50, message: ['configurator.errors.minimumWidth', {min: 50}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumHeight', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.Circle, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['d', 700]
    ]),
    validator: Validator.factory(MainShapeType.Circle),
    validators: [
        model => model.d < 50 ? {propName: 'd', propValue: 50, message: ['configurator.errors.minimumDiameter', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.HalfCircle, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['d', 700]
    ]),
    validator: Validator.factory(MainShapeType.HalfCircle),
    validators: [
        model => model.d < 50 ? {propName: 'd', propValue: 50, message: ['configurator.errors.minimumDiameter', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.QuarterCircle, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['d', 700]
    ]),
    validator: Validator.factory(MainShapeType.QuarterCircle),
    validators: [
        model => model.d < 50 ? {propName: 'd', propValue: 50, message: ['configurator.errors.minimumDiameter', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.Triangle, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700]
    ]),
    validator: Validator.factory(MainShapeType.Triangle),
    validators: [
        model => model.w < 50 ? {propName: 'w', propValue: 50, message: ['configurator.errors.minimumWidth', {min: 50}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumHeight', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.Trapezoid, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 700],
        ['h', 700],
        ['t1', 200],
        ['t2', 200]
    ]),
    validator: Validator.factory(MainShapeType.Trapezoid),
    validators: [
        model => model.w < 1 ? {propName: 'w', propValue: 1, message: ['configurator.errors.minimumUpperBaseWidth', {min: 1}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumHeight', {min: 50}]} : false,
        model => model.w + model.t1 + model.t2 < 50 ? {message: ['configurator.errors.minimumTotalWidth', {min: 50}]} : false
    ]
});

mainShapeParams.set(MainShapeType.Text, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['text', 'Text'],
        ['w', 1100],
        ['h', 350],
        ['fontName', FontLoaderFonts.Consolas.name],
        ['importantSize', 'h']
    ]),
    validator: Validator.factory(MainShapeType.Text),
    validators: [
        model => model.w < 50 ? {propName: 'w', propValue: 50, message: ['configurator.errors.minimumTextWidth', {min: 50}]} : false,
        model => model.h < 50 ? {propName: 'h', propValue: 50, message: ['configurator.errors.minimumTextHeight', {min: 50}]} : false,
        model => model.text === '' ? {message: ['configurator.errors.emptyText']} : false
    ]
});

mainShapeParams.set(MainShapeType.Arrow, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 800],
        ['h', 350],
        ['w2', 300],
        ['t', 175]
    ]),
    validator: Validator.factory(MainShapeType.Arrow),
    validators: [
        model => model.w < 1 ? {propName: 'w', propValue: 1, message: ['configurator.errors.minimumWidth', {min: 1}]} : false,
        model => model.h < 1 ? {propName: 'h', propValue: 1, message: ['configurator.errors.minimumHeight', {min: 1}]} : false,
        model => model.w2 < 0 ? {propName: 'w2', propValue: 0, message: ['configurator.errors.arrowheadNegativeWidth']} : false,
        model => model.t < 0 ? {propName: 't', propValue: 0, message: ['configurator.errors.arrowheadNegativeWidth']} : false,
        model => model.w + model.w2 < 50 ? {message: ['configurator.errors.minimumTotalWidth', {min: 50}]} : false,
        model => (model.h + (2 * model.t)) < 50 ? {message: ['configurator.errors.minimumTotalHeight', {min: 50}]} : false,
    ]
});

mainShapeParams.set(MainShapeType.Diamond, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 700],
        ['w2', 1100],
        ['h', 300],
        ['h2', 400]
    ]),
    validator: Validator.factory(MainShapeType.Diamond),
    validators: [
        model => model.w < 1 ? {propName: 'w', propValue: 1, message: ['configurator.errors.minimumTopWidth', {min: 1}]} : false,
        model => model.w2 < 0 ? {propName: 'w2', propValue: 0, message: ['configurator.errors.minimumBottomWidth', {min: 0}]} : false,
        model => model.w + model.w2 < 50 ? {message: ['configurator.errors.minimumTotalWidth', {min: 50}]} : false,
        model => model.h < 1 ? {propName: 'h', propValue: 1, message: ['configurator.errors.minimumTopHeight', {min: 1}]} : false,
        model => model.h2 < 0 ? {propName: 'h2', propValue: 0, message: ['configurator.errors.minimumBottomHeight', {min: 0}]} : false,
        model => model.h + model.h2 < 50 ? {message: ['configurator.errors.minimumTotalHeight', {min: 50}]} : false,
    ]
});

export default mainShapeParams;
